import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const teacherLoungeSummaryApi = createAsyncThunk(
    'analytics/teacherLoungeSummary',
    async (requestData, { rejectWithValue }) => {
        try {
            const { params } = requestData;
            const response = await AuthAxios.get(apiRoutes.teacherLoungeSummaryCard(), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const initialState = { result: null, loading: false, error: null, message: "" }

const teacherLoungeSummarySlice = createSlice({
    name: 'teacherLoungeSummary',
    initialState,
    reducers: {
        resetTeacherLoungeSummary: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(teacherLoungeSummaryApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(teacherLoungeSummaryApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload
        })
        builder.addCase(teacherLoungeSummaryApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
        })
    },
})

export const { resetTeacherLoungeSummary } = teacherLoungeSummarySlice.actions;
export const teacherLoungeSummaryReducer = teacherLoungeSummarySlice.reducer;
